module.exports = __webpack_public_path__ + "img/mg-reward-logo-en.30fdef19.png";